/**
 * VideoSlide - Gallery slide with background video and text overlay
 * Shows the Colagea serum application video with translated results text
 */

import { useRef, useEffect } from 'react';

const VIDEO_URL = 'https://colagea.com/cdn/shop/videos/c/vp/7cece6ac3e874a43924ffcb1b75f60e1/7cece6ac3e874a43924ffcb1b75f60e1.HD-1080p-3.3Mbps-62331898.mp4?v=0';

export default function VideoSlide() {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(() => {});
    }
  }, []);

  return (
    <div className="w-full h-full relative overflow-hidden bg-black">
      {/* Background Video */}
      <video
        ref={videoRef}
        className="absolute inset-0 w-full h-full object-cover"
        src={VIDEO_URL}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
      />
      
      {/* Bottom gradient overlay for readability */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
      
      {/* Top subtle overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-transparent h-1/4" />
      
      {/* Text content at bottom */}
      <div className="absolute bottom-0 left-0 right-0 p-4 lg:p-6 z-10">
        <p className="text-white text-sm lg:text-base leading-relaxed max-w-lg">
          Result: up to <span className="font-bold text-[#4d9fff]">4x greater absorption</span>, 
          revived <span className="font-bold text-[#4d9fff]">microcirculation</span>, and 
          visibly <span className="font-bold text-[#4d9fff]">renewed regrowth</span> from 
          the very first weeks.
        </p>
        <p className="text-white/40 text-[9px] lg:text-[10px] mt-2">Micro-Infuse&reg; Technology &mdash; Clinically Validated</p>
      </div>
    </div>
  );
}

/**
 * VideoSlide Thumbnail - Mini preview showing a play icon
 */
export function VideoSlideThumbnail() {
  return (
    <div className="w-full h-full bg-gradient-to-br from-gray-900 to-gray-800 flex flex-col items-center justify-center relative">
      {/* Play icon */}
      <div className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center mb-1">
        <svg className="w-3 h-3 text-white ml-0.5" viewBox="0 0 24 24" fill="currentColor">
          <path d="M8 5v14l11-7z" />
        </svg>
      </div>
      <span className="text-[5px] text-white/60 font-semibold uppercase tracking-wider">Video</span>
    </div>
  );
}
